import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Button from '../components/UI/Button';

const LegalNotice: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8 flex items-center">
          <Button 
            variant="ghost" 
            className="mr-4"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-3xl font-bold">Mentions Légales</h1>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8 space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-4">Éditeur du site</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Le site est édité par :<br />
              HLH Invest Corp<br />
              Société enregistrée aux États-Unis<br />
              Adresse : 651 N Broad St, New Castle, DE 19709, États-Unis<br />
              Adresse e-mail de contact : contact@invoice-ai.fr
            </p>
            <p className="text-gray-600 dark:text-gray-400 mt-2">
              Directeur de la publication : HLH Invest Corp
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">Hébergement</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Le site est hébergé par :<br />
              Netlify, Inc.<br />
              2325 3rd Street, Suite 215<br />
              San Francisco, California 94107<br />
              États-Unis
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">Propriété intellectuelle</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Tous les éléments accessibles sur le site (textes, images, logo, structure, technologie sous-jacente, etc.) 
              sont protégés par les droits de propriété intellectuelle et sont la propriété exclusive de HLH Invest Corp, 
              sauf indication contraire.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">Données personnelles</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Les données personnelles collectées via le site sont traitées conformément à la réglementation en vigueur. 
              Pour plus d'informations, veuillez consulter notre Politique de confidentialité.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">Conditions d'utilisation</h2>
            <p className="text-gray-600 dark:text-gray-400">
              L'accès et l'utilisation du site impliquent l'acceptation pleine et entière des Conditions Générales 
              d'Utilisation disponibles sur la page dédiée.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default LegalNotice;